import {combineReducers} from 'redux';
import {typeExport} from "./type";
import {Platform} from "react-native";
const NO_SHOW_INSTALL_PWA = 'NO_SHOW_INSTALL_PWA';

const defaultBirds = {
    noShowInstallPwa: false,
    views: 1,
};

function reducerAll(state = defaultBirds, action) {
    switch (action.type) {
        case NO_SHOW_INSTALL_PWA:
            return {
                ...state,
                noShowInstallPwa: action.data,
                views: 1
            };

        default:
            return state;
    }
}

function f() {
    const reducerSplashSatiaScreen = require("../../screens/satia/splash/reducer/ReducerSplashSatiaScreen").default;
    const reducerSplashGetAllData = require("../../screens/137/splash/reducer/ReducerSplashGetAllData").default;


    switch (typeExport._TypeApp) {

        case "Satia":
            //Satia
            const reducerEnterCodeSatiaScreen = require("../../screens/satia/login/enterCode/reducer/ReducerEnterCodeSatiaScreen").default;
            const reducerLoginEnterPhoneCodeSatiaScreen = require("../../screens/satia/login/enterMobile/reducer/ReducerLoginEnterPhoneCodeSatiaScreen").default;
            const reducerPaySatiaScreen = require("../../screens/satia/main/pay/reducer/ReducerPaySatiaScreen").default;
            const reducerListMicroConsumptionSatiaScreen = require("../../screens/satia/main/internetUsage/reducer/ReducerListMicroConsumptionSatiaScreen").default;
            const reducerListHistoryTelephoneLineStatusSatiaScreen = require("../../screens/satia/main/listHistoryLineStatus/reducer/ReducerListHistoryTelephoneLineStatusSatiaScreen").default;
            const reducerListServiceHistorySatiaScreen = require("../../screens/satia/main/listServiceHistory/reducer/ReducerListServiceHistorySatiaScreen").default;
            const reducerListMessageSatiaScreen = require("../../screens/satia/main/listMessage/reducer/ReducerListMessageSatiaScreen").default;
            const reducerListOnlineChargingHistorySatiaScreen = require("../../screens/satia/main/listHistoryBuyCredit/reducer/ReducerListOnlineChargingHistorySatiaScreen").default;
            const reducerListQuestionAndAnswerSatiaScreen = require("../../screens/satia/main/listMessageOperation/reducer/ReducerListQuestionAndAnswerSatiaScreen").default;
            const reducerListMessageOperatorSatiaScreen = require("../../screens/satia/main/listMessageOperation/reducer/ReducerListMessageOperatorSatiaScreen").default;
            const reducerChangeInformationSatiaScreen = require("../../screens/satia/main/profile/reducer/ReducerChangeInformationSatiaScreen").default;
            const reducerUploadDocumentSatiaScreen = require("../../screens/satia/main/profile/reducer/ReducerUploadDocumentSatiaScreen").default;
            const reducerAddTaskOperationSatiaScreen = require("../../screens/satia/main/operation/reducer/ReducerAddTaskOperationSatiaScreen").default;
            const reducerDetailsTaskOperationSatiaScreen = require("../../screens/satia/main/operation/reducer/ReducerDetailsTaskOperationSatiaScreen").default;
            const reducerLoginEnterUsernameSatiaScreen = require("../../screens/satia/login/enterUsername/reducer/ReducerLoginEnterUsernameSatiaScreen").default;
            const reducerListTaskOperationSatiaScreen = require("../../screens/satia/main/operation/reducer/ReducerListTaskOperationSatiaScreen").default;
            const reducerListReportTaskOperationSatiaScreen = require("../../screens/satia/main/operation/reducer/ReducerListReportTaskOperationSatiaScreen").default;
            const reducerListVirtualBankSatiaScreen = require("../../screens/satia/main/virtualBank/reducer/ReducerListVirtualBankSatiaScreen").default;
            const reducerIncreaseCreditSatiaScreen = require("../../screens/satia/main/virtualBank/reducer/ReducerIncreaseCreditSatiaScreen").default;
            const reducerInformationSatiaScreen = require("../../screens/satia/login/information/reducer/ReducerInformationSatiaScreen").default;
            return combineReducers({
                reducerSplashGetAllData,
                //Satia
                reducerSplashSatiaScreen,
                reducerLoginEnterPhoneCodeSatiaScreen,
                reducerEnterCodeSatiaScreen,
                reducerPaySatiaScreen,
                reducerListMicroConsumptionSatiaScreen,
                reducerListHistoryTelephoneLineStatusSatiaScreen,
                reducerListServiceHistorySatiaScreen,
                reducerListMessageSatiaScreen,
                reducerListOnlineChargingHistorySatiaScreen,
                reducerListQuestionAndAnswerSatiaScreen,
                reducerListMessageOperatorSatiaScreen,
                reducerChangeInformationSatiaScreen,
                reducerUploadDocumentSatiaScreen,
                reducerInformationSatiaScreen,
                reducerListTaskOperationSatiaScreen,
                reducerAddTaskOperationSatiaScreen,
                reducerDetailsTaskOperationSatiaScreen,
                reducerLoginEnterUsernameSatiaScreen,
                reducerListReportTaskOperationSatiaScreen,
                reducerListVirtualBankSatiaScreen,
                reducerIncreaseCreditSatiaScreen,

                reducerAll,
            })


//137
        case "1888":
        case "137":
            //137


            const reducerListNewsScreen = require("../../screens/137/main/news/reducer/ReducerListNewsScreen").default;
            const reducerLoginScreen = require("../../screens/137/login/reducer/ReducerLoginScreen").default;
            const reducerEnterCodeScreen = require("../../screens/137/login/code/reducer/ReducerEnterCodeScreen").default;
            const reducerInformationScreen = require("../../screens/137/login/informaion/reducer/ReducerInformationScreen").default;
            const reducerLoginEnterPhoneCodeScreen = require("../../screens/137/login/loginMobile/reducer/ReducerLoginEnterPhoneCodeScreen").default;
            const reducerLoginEnterPhoneScreen = require("../../screens/137/login/loginUsername/reducer/ReducerLoginEnterPhoneScreen").default;
            const reducerApplyScreen = require("../../screens/137/main/applay/reducer/ReducerApplyScreen").default;
            const reducerDetailsScreen = require("../../screens/137/main/details/reducer/ReducerDetailsScreen").default;
            const reducerCategoryScreen = require("../../screens/137/main/category/reducer/ReducerCategoryScreen").default;
            const reducerListDeadScreen = require("../../screens/137/main/pageGraveyard/reducer/ReducerListDeadScreen").default;
            const reducerListMyApplyScreen = require("../../screens/137/main/applay/reducer/ReducerListMyApplyScreen").default;
            const reducerListMyApplyOperationScreen = require("../../screens/137/main/applay/reducer/ReducerListMyApplyOperationScreen").default;
            const reducerListMyRegisterComplaintsScreen = require("../../screens/137/main/applay/reducer/ReducerListMyRegisterComplaintsScreen").default;
            const reducerListOperatorApplyScreen = require("../../screens/137/main/applay/reducer/ReducerListOperatorApplyScreen").default;
            const reducerSubmitRequestScreen22 = require("../../screens/137/main/applay/submitRequest/reducer/ReducerSubmitRequestScreen22").default;
            const reducerDetailsRequestScreen = require("../../screens/137/main/applay/reducer/ReducerDetailsRequestScreen").default;
            const reducerRegisterComplaintsScreen = require("../../screens/137/main/applay/submitComplaint/reducer/ReducerRegisterComplaintsScreen").default;
            const reducerChangPssScreen = require("../../screens/137/login/changePass/reducer/ReducerChangPssScreen").default;
            const reducerChangeInformationScreen = require("../../screens/137/login/changeInformatin/reducer/ReducerChangeInformationScreen").default;
            const reducerMyApplyScreen = require("../../screens/137/main/applay/reducer/ReducerMyApplyScreen").default;
            const reducerSubmitSwitchingOperationScreen = require("../../screens/137/main/applay/submitSwitch/reducer/reducerSubmitSwitchingOperationScreen").default;
            const reducerDetailsOperatorApplyScreen = require("../../screens/137/main/applay/reducer/ReducerDetailsOperatorApplyScreen").default;
            const reducerGalleryServiceOperationScreen = require("../../screens/137/main/applay/reducer/ReducerGalleryServiceOperationScreen").default;
            const reducerGalleryServiceScreen = require("../../screens/137/main/applay/reducer/ReducerGalleryServiceScreen").default;
            const reducerListMessageChatScreen = require("../../screens/common/chat/reducer/ReducerListMessageChatScreen").default;
            const reducerListUserChatScreen = require("../../screens/common/chat/reducer/ReducerListUserCahtScreen").default;

            const reducerListReportArrearsScreen = require("../../screens/137/main/reports/reducer/ReducerListReportArrearsScreen").default;
            const reducerListReport15RequestScreen = require("../../screens/137/main/reports/reducer/ReducerListReport15RequestScreen").default;
            const reducerListReport15RequestScreen2 = require("../../screens/137/main/reports/reducer/ReducerListReport15RequestScreen2").default;
            const reducerListReportStatusRequestScreen = require("../../screens/137/main/reports/reducer/ReducerListReportStatusRequestScreen").default;
            const reducerListReportStatusRequestScreen2 = require("../../screens/137/main/reports/reducer/ReducerListReportStatusRequestScreen2").default;
            const reducerListReportTaskRequestScreen = require("../../screens/137/main/reports/reducer/ReducerListReportTaskRequestScreen").default;
            const reducerSubmitSendOperationScreen = require("../../screens/137/main/applay/submitSend/reducer/ReducerSubmitSendOperationScreen").default;
            const reducerExpertRegistrationMahaleMaScreen = require("../../screens/137/main/reports/mahaleMa/reducer/ReducerExpertRegistrationMahaleMaScreen").default;
            const reducerListReportMahalehMaScreen = require("../../screens/137/main/reports/mahaleMa/reducer/ReducerListReportMahalehMaScreen").default;
            const reducerListReportExitEnterMahalehMaScreen = require("../../screens/137/main/reports/mahaleMa/reducer/ReducerListReportExitEnterMahalehMaScreen").default;

            return combineReducers({
                reducerSplashSatiaScreen,
                //137
                reducerSplashGetAllData,
                reducerListNewsScreen,
                reducerLoginScreen,
                reducerEnterCodeScreen,
                reducerInformationScreen,
                reducerLoginEnterPhoneCodeScreen,
                reducerLoginEnterPhoneScreen,
                reducerApplyScreen,
                reducerDetailsScreen,
                reducerCategoryScreen,
                reducerListDeadScreen,
                reducerListMyApplyScreen,
                reducerListMyApplyOperationScreen,
                reducerListMyRegisterComplaintsScreen,
                reducerListOperatorApplyScreen,
                reducerSubmitRequestScreen22,
                reducerDetailsRequestScreen,
                reducerRegisterComplaintsScreen,
                reducerChangPssScreen,
                reducerChangeInformationScreen,
                reducerMyApplyScreen,
                reducerSubmitSwitchingOperationScreen,
                reducerDetailsOperatorApplyScreen,
                reducerGalleryServiceOperationScreen,
                reducerGalleryServiceScreen,
                reducerListReportArrearsScreen,
                reducerListReport15RequestScreen,
                reducerListReport15RequestScreen2,
                reducerListReportStatusRequestScreen,
                reducerListReportStatusRequestScreen2,
                reducerListReportTaskRequestScreen,
                reducerSubmitSendOperationScreen,
                reducerExpertRegistrationMahaleMaScreen,
                reducerListReportMahalehMaScreen,
                reducerListReportExitEnterMahalehMaScreen,
                //common
                reducerListMessageChatScreen,
                reducerListUserChatScreen,

                reducerAll,
            })
        //125
        case "125":
            const reducerListOperatorFireApplyScreen = require("../../screens/125/main/reducer/ReducerListOperatorFireApplyScreen").default;
            const reducerDetailsOperatorFireApplyScreen = require("../../screens/125/main/reducer/ReducerDetailsOperatorFireApplyScreen").default;
            const reducerSubmitRequestOperationFireScreen = require("../../screens/125/main/reducer/reducerSubmitRequestOperationFireScreen").default;
            const reducerLoginScreen125 = require("../../screens/137/login/reducer/ReducerLoginScreen").default;
            const reducerEnterCodeScreen125 = require("../../screens/137/login/code/reducer/ReducerEnterCodeScreen").default;
            const reducerInformationScreen125 = require("../../screens/137/login/informaion/reducer/ReducerInformationScreen").default;
            const reducerLoginEnterPhoneCodeScreen125 = require("../../screens/137/login/loginMobile/reducer/ReducerLoginEnterPhoneCodeScreen").default;
            const reducerLoginEnterPhoneScreen125 = require("../../screens/137/login/loginUsername/reducer/ReducerLoginEnterPhoneScreen").default;
            return combineReducers({

                reducerSplashGetAllData,
                reducerSplashSatiaScreen,
                //125
                reducerListOperatorFireApplyScreen,
                reducerDetailsOperatorFireApplyScreen,
                reducerSubmitRequestOperationFireScreen,

                reducerLoginScreen: reducerLoginScreen125,
                reducerEnterCodeScreen: reducerEnterCodeScreen125,
                reducerInformationScreen: reducerInformationScreen125,
                reducerLoginEnterPhoneCodeScreen: reducerLoginEnterPhoneCodeScreen125,
                reducerLoginEnterPhoneScreen: reducerLoginEnterPhoneScreen125,
                reducerAll,
            })
    }
}

const AppReducers = f();
/*const AppReducers = combineReducers({
    //Satia
    reducerSplashSatiaScreen,
    reducerLoginEnterPhoneCodeSatiaScreen,
    reducerEnterCodeSatiaScreen,
    reducerPaySatiaScreen,
    reducerListMicroConsumptionSatiaScreen,
    reducerListHistoryTelephoneLineStatusSatiaScreen,
    reducerListServiceHistorySatiaScreen,
    reducerListMessageSatiaScreen,
    reducerListOnlineChargingHistorySatiaScreen,
    reducerListQuestionAndAnswerSatiaScreen,
    reducerListMessageOperatorSatiaScreen,
    reducerChangeInformationSatiaScreen,
    reducerUploadDocumentSatiaScreen,
    reducerInformationSatiaScreen,
   reducerListTaskOperationSatiaScreen,
    reducerAddTaskOperationSatiaScreen,
    reducerDetailsTaskOperationSatiaScreen,
    reducerLoginEnterUsernameSatiaScreen,
   reducerListReportTaskOperationSatiaScreen,
    reducerListVirtualBankSatiaScreen,

    //137
    reducerSplashGetAllData,
    reducerListNewsScreen,
    reducerLoginScreen,
    reducerEnterCodeScreen,
    reducerInformationScreen,
    reducerLoginEnterPhoneCodeScreen,
    reducerLoginEnterPhoneScreen,
    reducerApplyScreen,
    reducerDetailsScreen,
    reducerCategoryScreen,
    reducerListDeadScreen,
    reducerListMyApplyScreen,
    reducerListMyApplyOperationScreen,
    reducerListMyRegisterComplaintsScreen,
    reducerListOperatorApplyScreen,
    reducerSubmitRequestScreen22,
    reducerDetailsRequestScreen,
    reducerRegisterComplaintsScreen,
    reducerChangPssScreen,
    reducerChangeInformationScreen,
    reducerMyApplyScreen,
    reducerSubmitSwitchingOperationScreen,
    reducerDetailsOperatorApplyScreen,
    reducerGalleryServiceOperationScreen,
    reducerGalleryServiceScreen,
    reducerListReport15RequestScreen,
    reducerListReportStatusRequestScreen,
    reducerListReportTaskRequestScreen,
    reducerSubmitSendOperationScreen,
    //common
    reducerListMessageChatScreen,
    reducerListUserChatScreen,


    //125
    reducerListOperatorFireApplyScreen,
    reducerDetailsOperatorFireApplyScreen,
    reducerSubmitRequestOperationFireScreen,

});*/

const rootReducer = (state, action) => {
    return AppReducers(state, action);
}


export default rootReducer;

